module.exports = __webpack_public_path__ + "static/media/guide.60179140.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/guide.png
// module id = 2000
// module chunks = 6